require('./RASuitabilityTestView.scss');
require('./RASuitabilityTestView.override.scss');

// @vendors
const React = require('react');
const { withRouter } = require('react-router-dom');
const PropTypes = require('prop-types');
const { connect } = require('react-redux');
const classNames = require('classnames');
const moment = require('moment');

// @commons
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKCover } = require('commonsComponents/OKCover');
const { OKButton } = require('components/commons/OKButton/OKButton');
const OKSliderInput = require('commonsComponents/OKSliderInput');
const { OKLink } = require('commonsComponents/OKLink');
const Avatar = require('components/avatar/avatar');
const FormattedTextWithComponents = require('components/broker/brokerFormattedTextWithComponents/brokerFormattedTextWithComponents');
const RAIncomingOutgoingStep = require('../../components/RAIncomingOutgoingStep/RAIncomingOutgoingStep');
const RASuitabilityTestModal = require('../../components/RASuitabilityTestModal/RASuitabilityTestModal');
const RASuitabilityTestRetryModal = require('../../components/RASuitabilityTestRetryModal/RASuitabilityTestRetryModal');

// @components
const { OKMessage } = require('commonsComponents/OKMessage');
const RAInvestmentHorizonInput = require('../../components/RAInvestmentHorizonSlider/RAInvestmentHorizonInput/RAInvestmentHorizonInput');
const RARadialMenu = require('../../components/RARadialMenu/RARadialMenu');
const RARadioButtonStep = require('../../components/RARadioButtonStep/RARadioButtonStep');
const RASuitabilityTestFailure = require('./RASuitabilityTestFailure/RASuitabilityTestFailure');
const RASuitabilityTestSuccess = require('./RASuitabilityTestSuccess/RASuitabilityTestSuccess');
const RAWizard = require('../../components/RAWizard/RAWizard');
const RAWizardCategory = require('../../components/RAWizard/RAWizardCategory');
const RAWizardStep = require('../../components/RAWizard/RAWizardStep');
const RAVerticalSliderStep = require('../../components/RAVerticalSliderStep/RAVerticalSliderStep');
const RAAccordionStep = require('../../components/RAAccordionStep/RAAccordionStep');
const RANetworthPercentageSlider = require('../../components/RANetworthPercentageSlider/RANetworthPercentageSlider');
const RACoherenceModal = require('../../components/RACoherenceModal/RACoherenceModal');
const RANonresidentialModal = require('../../components/RANonresidentialModal/RANonresidentialModal');
const RASuitabilityTestFailureDisclaimer = require('../../components/RASuitabilityTestFailureDisclaimer/RASuitabilityTestFailureDisclaimer');
const RASustainabilityQuestion = require('../../components/RASustainabilityQuestion/RASustainabilityQuestion');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');

const {
    ModalUsPersonBlock,
} = require('components/commons/modalUsPersonBlock/modalUsPersonBlock');
const RAFirstAnswerModal = require('../../components/RAFirstAnswerModal/RAFirstAnswerModal');

// @actions
const screenActions = require('actions/screen');
const suitabilityActions = require('../../actions/RASuitabilityTest');
const wizardActions = require('../../actions/RAWizard');
const profileActions = require('actions/profile');

// @utilites
const { FormattedText, formatText } = require('core/i18n').i18n;
const { toCamelCase } = require('utilities/stringHelper');
const { scrollToTop } = require('commonsUtilities/scrollUtils');
const PersonalDataHelper = require('utilities/personalDataHelper');
const DateHelper = require('utilities/dateHelper');
const { getFormattedLanguage } = require('../../utilities/RALanguageHelper');
const {
    isNoValidTest,
    isTestValid,
} = require('../../utilities/RASuitabilityTestHelper');
const {
    recordLink,
    recordLinkV2,
    recordProcess,
    PROC_RA_SUITABILITY_TEST,
    PROC_START,
} = require('utilities/tagging');

// @constants
const {
    LANGUAGE_ES,
    SUITABILITY_TEST,
    SUITABILITY_TEST_STEP_1,
    SUITABILITY_TEST_STEP_2,
    SUITABILITY_TEST_STEP_3,
    SUITABILITY_TEST_STEP_3_1,
    SUITABILITY_TEST_STEP_4,
    SUITABILITY_TEST_STEP_5,
    SUITABILITY_TEST_STEP_6,
    SUITABILITY_TEST_STEP_7,
    SUITABILITY_TEST_STEP_8,
    SUITABILITY_TEST_STEP_9,
    SUITABILITY_TEST_STEP_10,
    SUITABILITY_TEST_STEP_11,
    SUITABILITY_TEST_STEP_12,
    SUITABILITY_TEST_CATEGORY_1,
    SUITABILITY_TEST_CATEGORY_2,
    SUITABILITY_TEST_CATEGORY_3,
    SUITABILITY_TEST_STATUS_URL,
    SUITABILITY_TEST_VALID,
    MYPROFILE_BROKER_ROBO_URL,
    PROC_RA_SUITABILITY_TEST_INTERACTION,
    PROC_RA_SUITABILITY_TEST_ACCESS_MODAL,
    PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
    PROC_RA_SUITABILITY_TEST_HANDLE_CLOSE,
    PROC_RA_SUITABILITY_TEST_NEW_TEST,
    PROC_RA_SUITABILITY_TEST_RETRY_TEST,
    PROC_RA_CANCEL,
    PROC_RA_SUITABILITY_TEST_VIEW,
    RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER,
    RA_MODAL_TYPE_1,
    RA_MODAL_TYPE_2,
    RA_MODAL_TYPE_3,
    RA_MODAL_TYPE_5,
    RA_MODAL_TYPE_6,
    RA_INVESTMENT_HORIZON_SLIDER_MAX,
    RA_INVESTMENT_HORIZON_SLIDER_MIN,
    RA_SUITABILITY_TEST_HEAD_OPERATION,
    RA_SUITABILITY_TEST_HIRE_OPERATION,
    RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION,
    RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION,
    RA_SUITABILITY_TEST_DISPLAY_LEAVE_MODAL,
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1,
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_STATUS,
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_CLOSE,
    PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_OPEN,
    PROC_RA_SUITABILITY_TEST_PROCCESS,
    PROC_RA_SUITABILITY_PAGE_NAME,
    SUITABILITY_TEST_NO_TEST,
} = require('../../raConstants/index');
const KNOW_LEDGE = '101';
const FINANCIAL_EXPERIENCE = '104';
const RADIAL_MENU_SUBTITLE = '217';
const INVESTMENT_HORIZON_SLIDER_SUBTITLE = '218';
const VOLATILITY_SUBTITLE = '219';
const INCOMING_OUTGOINGS = '320';
const capitalRatiosubtitle = '322';
const BACKUP_PLAN_TITLE = '323';
const {
    MODIFY_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
    SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
    MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
    SUITABILITY_TEST_V6,
} = require('constants/flagBasedFeatures');

const {
    DATE_FORMAT_COMPLETE,
    FIRST_STEP,
    BROKER_PG_ROBO_URL,
} = require('constants/index');

// @Contact Center
const {
    RA_ZERO_QUESTION_ID,
    SUITABILITY_TEST_CATEGORY_0,
    SUITABILITY_TEST_STEP_0,
} = require('../../raConstants/contactCenter/zeroQuestionCodes');
const {
    zeroQuestionPresent,
} = require('../../utilities/contactCenter/RAZeroQuestionHelper');
const CustomMessageBox = require('components/contactCenter/customMessageBox/customMessageBox');
const RAErrorFetchingCountryOfResidenceModal = require('../../components/contactCenter/RAErrorFetchingCountryOfResidenceModal/RAErrorFetchingCountryOfResidenceModal');
const RASuitabilityTestZeroQuestionLegalText = require('../../components/contactCenter/RASuitabilityTestZeroQuestionLegalText/RASuitabilityTestZeroQuestionLegalText');
const {
    canFinishOperative,
} = require('../../utilities/contactCenter/RACanFinishOperativeHelper');
const RASustainabilityInvestmentFactorsQuestion = require('../../components/RASustainabilityInvestmentFactorsQuestion/RASustainabilityInvestmentFactorsQuestion');

class RASuitabilityTestView extends React.Component {
    constructor(props) {
        super(props);

        this.closeModal = this.closeModal.bind(this);
        this.handleCancel = this.handleCancel.bind(this);
        this.handleConfirm = this.handleConfirm.bind(this);
        this.handleFinish = this.handleFinish.bind(this);
        this.handleNextModal = this.handleNextModal.bind(this);
        this.handleLogoClick = this.handleLogoClick.bind(this);
        this.handleToggleModal = this.handleToggleModal.bind(this);
        this.handleUpdateObjective = this.handleUpdateObjective.bind(this);
        this.handleUpdateTHValue = this.handleUpdateTHValue.bind(this);
        this.handleCloseAccessModal = this.handleCloseAccessModal.bind(this);
        this.handleContinueFromWarningModal = this.handleContinueFromWarningModal.bind(
            this,
        );
        this.handleContinueAccessModal = this.handleContinueAccessModal.bind(
            this,
        );
        this.handleNewTestClick = this.handleNewTestClick.bind(this);
        this.onHandleRetryModalAccept = this.onHandleRetryModalAccept.bind(
            this,
        );
        this.onHandleRetryModalClose = this.onHandleRetryModalClose.bind(this);
        this.onHandleRetryModalCancel = this.onHandleRetryModalCancel.bind(
            this,
        );
        this.handleRetryReasonChange = this.handleRetryReasonChange.bind(this);
        this.handleToggleErrorFetchingCountryOfResidenceModal = this.handleToggleErrorFetchingCountryOfResidenceModal.bind(
            this,
        );
        this.handleGoBackToTestStatus = this.handleGoBackToTestStatus.bind(
            this,
        );
        this.state = {
            showAccessModal: true,
            showRetryModal: false,
            showAdditionalQuestions: false,
            isAccordionHeaderHidden: true,
            isAccordionExpanded: true,
        };
    }

    componentWillMount() {
        const { immCheckStatus } = this.props;

        if (immCheckStatus.get('checkStatus') === SUITABILITY_TEST_VALID) {
            // TODO: query if the user already has done suitability test
        }
    }

    componentDidMount() {
        const {
            immCheckStatus,
            match: {
                params: { readOnly },
            },
            hideAppHeader,
            getTestQuestions,
            immBrokerConsultMiFID,
            immProfile,
            immSuitabilityTest,
            validateResidentiality,
        } = this.props;
        validateResidentiality(immProfile, 'objectivo');
        hideAppHeader();
        if (immBrokerConsultMiFID.get('fetched')) {
            getTestQuestions(!!readOnly);
        }

        if (
            !immSuitabilityTest.get('buttonRenewClicked') &&
            !!immSuitabilityTest.get('retryTest') &&
            !immCheckStatus.get('unSignedTest') &&
            !immCheckStatus.get('testInProgress')
        ) {
            this.setState({
                // eslint-disable-line
                showRetryModal: true,
            });
        }
        if (
            !immSuitabilityTest.get('retryTest') &&
            this.isTestCompleted() &&
            !immCheckStatus.get('nonSuitableTest') &&
            !immCheckStatus.get('testInProgress') &&
            !immCheckStatus.get('canRepeatTest')
        ) {
            this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
        }

        if (!__CONTACT_CENTER__) {
            if (immCheckStatus.get('newRoboCustomer')) {
                recordProcess(PROC_RA_SUITABILITY_TEST, PROC_START);
            }
        } else {
            if (
                !readOnly &&
                !immCheckStatus.get('canRepeatTest') &&
                !immCheckStatus.get('newRoboCustomer') &&
                !immCheckStatus.get('nonSuitableTest')
            ) {
                this.props.history.push(SUITABILITY_TEST_STATUS_URL);
            }
        }

        if (immCheckStatus.get('nonSuitableTest')) {
            this.props.resetTestCompleted();
        }

        if (
            immCheckStatus.get('checkStatusFetched') &&
            immCheckStatus.get('checkStatus') === SUITABILITY_TEST_NO_TEST
        ) {
            recordLinkV2({
                categoriaEvento: 'test de idoneidad',
                accionEvento: 'primera vez',
                etiquetaEvento: 'inicio',
                action: 'start',
                format: 'firstTime',
                component: 'suitabilityTest',
                element: 'backend',
            });
        }
    }

    componentDidUpdate(prevProps) {
        const prevCurrentStepIndex = prevProps.immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'currentStepIndex',
        ]);
        const currentStepIndex = this.props.immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'currentStepIndex',
        ]);

        if (
            (!isNaN(prevCurrentStepIndex) &&
                !isNaN(currentStepIndex) &&
                prevCurrentStepIndex !== currentStepIndex) ||
            (currentStepIndex === 0 && prevCurrentStepIndex === undefined)
        ) {
            const categories = this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'categories',
            ]);
            const currentCategoryIndex = this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'currentCategory',
            ]);
            const currentSubCategoryIndex = this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'currentStep',
            ]);
            const currentSubCategories = categories
                .get(currentCategoryIndex)
                .get('steps');
            const currentSubCatgoryName = currentSubCategories
                .get(currentSubCategoryIndex)
                .get('name');

            const customData = {
                nombrePagina: PROC_RA_SUITABILITY_PAGE_NAME,
                tipoProceso: PROC_RA_SUITABILITY_TEST_PROCCESS,
                pasoProceso: 'paso_' + (currentStepIndex + 1),
                detalleProceso: currentSubCatgoryName,
            };
            window &&
                window.utag &&
                window.utag.view &&
                window.utag.view(customData);
        }
    }

    componentWillUnmount() {
        this.props.reset();
        this.props.showAppHeader();
    }

    handleUpdateObjective(value) {
        this.props.updateObjective(value);
    }

    handleUpdateTHValue(value) {
        this.props.updateTemporalHorizonValue(value);
    }

    handleConfirm() {
        this.props.signTest(this.props.history);
    }

    handleLogoClick() {
        this.props.history.push('/myprofile/broker');
    }

    finishTest(totalAnswers) {
        const { sendTest, history } = this.props;
        const { immWizard } = this.props;
        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'currentStepIndex',
        ]);
        this.props.validateStep(
            SUITABILITY_TEST,
            currentStepIndex,
            'finalStep',
        );
        scrollToTop();
        sendTest(history, true, totalAnswers);
    }

    handleFinish(totalAnswers) {
        const {
            immFlagBasedFeatures,
            immSuitabilityTest,
            immWizard,
            showModalNewQuestions,
            setTotalAnswers,
            sendLogs,
        } = this.props;
        const immAnswers = immSuitabilityTest.get('answers');
        let countAnswer = 0;
        const validateQuestionsAndAnswer = [
            { question: '403', answer: 'answer1' },
            { question: '403', answer: 'answer2' },
            { question: '404', answer: 'answer1' },
            { question: '405', answer: 'answer1' },
        ];

        if (
            immFlagBasedFeatures.get(
                SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
            ) &&
            !immFlagBasedFeatures.get(SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST)
        ) {
            setTotalAnswers(totalAnswers);
            validateQuestionsAndAnswer.forEach(item => {
                immAnswers.get(item.question) === item.answer && countAnswer++;
            });
            const immCurrentWizard = immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
            ]);
            const currentStep = immCurrentWizard.getIn([
                'categories',
                immCurrentWizard.get('currentCategory'),
                'steps',
                immCurrentWizard.get('currentStep'),
            ]);
            sendLogs(currentStep.get('identifier'));
            if (
                countAnswer === 3 ||
                immAnswers.get('401') === 'answer1' ||
                immAnswers.get('402') !== 'answer3'
            ) {
                this.finishTest(totalAnswers);
            } else {
                const { immWizard } = this.props;
                const currentStepIndex = immWizard.getIn([
                    'persistedWizards',
                    SUITABILITY_TEST,
                    'currentStepIndex',
                ]);
                this.props.validateStep(
                    SUITABILITY_TEST,
                    currentStepIndex,
                    'finalStep',
                );
                showModalNewQuestions(true);
            }
        } else {
            this.finishTest(totalAnswers);
        }
    }

    isTestCompleted() {
        const {
            immCheckStatus,
            match: {
                params: { readOnly },
            },
        } = this.props;

        const suitabilityTestIsValid =
            !__CONTACT_CENTER__ &&
            immCheckStatus.get('checkStatusFetched') &&
            isTestValid(immCheckStatus);
        return suitabilityTestIsValid && !readOnly;
    }

    closeModal() {
        this.props.showModal(SUITABILITY_TEST, false);
    }

    handleContinueFromWarningModal() {
        this.closeModal();
        const { immWizard } = this.props;
        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'currentStepIndex',
        ]);
        scrollToTop();
        this.props.continueFromModalWarning(
            SUITABILITY_TEST,
            currentStepIndex,
            '+1',
        );
        this.props.showModal(SUITABILITY_TEST, false);
    }

    handleCancel() {
        const { immWizard, history } = this.props;
        recordLink('vista modal salir', 'salir del test');

        const lastStepIndex = immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'lastStepIndex',
        ]);
        const shouldSave = lastStepIndex > FIRST_STEP;

        if (shouldSave) {
            this.props.sendTest(history, false);
        }
    }

    handleNextModal() {
        const {
            immWizard,
            cleanCovenientsQuestions,
            immFlagBasedFeatures,
        } = this.props;
        const currentStepIndex = immWizard.getIn([
            'persistedWizards',
            SUITABILITY_TEST,
            'currentStepIndex',
        ]);
        scrollToTop();
        if (
            this.props.immSuitabilityTest.getIn(['answers', '101']) ===
                'answer1' &&
            !immFlagBasedFeatures.get(SUITABILITY_TEST_V6)
        ) {
            const nextStep = this.props.immSuitabilityTest.getIn([
                'questions',
                '702',
            ])
                ? 5
                : 4;
            this.props.validateStep(
                SUITABILITY_TEST,
                currentStepIndex,
                nextStep,
            );
            recordLink(
                PROC_RA_SUITABILITY_TEST,
                PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1,
                PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_CLOSE,
            );
            cleanCovenientsQuestions();
        } else {
            this.props.validateStep(SUITABILITY_TEST, currentStepIndex, '+1');
        }
        this.props.showModal(SUITABILITY_TEST, false);
        this.props.showFirstAnswerModal(SUITABILITY_TEST, false);
    }

    handleCloseAccessModal() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_ACCESS_MODAL,
            PROC_RA_SUITABILITY_TEST_HANDLE_CLOSE,
        );
        this.setState({
            showAccessModal: false,
        });
    }

    onHandleRetryModalAccept() {
        const { immSuitabilityTest } = this.props;
        const selectedReason = immSuitabilityTest.get('retryReason');
        const answer = 'continuar ' + selectedReason;
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
            answer,
        );
        this.setState({
            showRetryModal: false,
        });
    }

    onHandleRetryModalClose() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
            PROC_RA_SUITABILITY_TEST_HANDLE_CLOSE,
        );
        this.props.history.push(SUITABILITY_TEST_STATUS_URL);
    }

    onHandleRetryModalCancel() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_RETRY_MODAL,
            PROC_RA_CANCEL,
        );
        this.props.history.push(SUITABILITY_TEST_STATUS_URL);
    }

    handleContinueAccessModal() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_ACCESS_MODAL,
            PROC_RA_SUITABILITY_TEST_RETRY_TEST,
        );
        this.setState({
            showAccessModal: false,
        });
    }

    handleNewTestClick() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_ACCESS_MODAL,
            PROC_RA_SUITABILITY_TEST_NEW_TEST,
        );
        this.props.resetAnswers();
        this.handleCloseAccessModal();
    }

    handleRetryReasonChange(value) {
        this.props.setRetryReason(value);
    }

    buildCategoriesHeader(readOnly) {
        if (!readOnly) {
            return null;
        }

        const { immSuitabilityTest } = this.props;
        const date = immSuitabilityTest.getIn(['results', 0, 'signed']);
        const formattedDate = DateHelper.buildFormattedDate(
            moment(date),
            DATE_FORMAT_COMPLETE,
        );

        const testDate = (
            <span className="ra-suitability-test-view__categories-header-date">
                {formattedDate}
            </span>
        );
        return (
            <div className="ra-suitability-test-view__categories-header">
                <FormattedTextWithComponents
                    value="raSuitabilityTest-lastTestDate"
                    injectedComponents={[testDate]}
                />
            </div>
        );
    }

    handleGoBackToTestStatus() {
        this.props.history.push(SUITABILITY_TEST_STATUS_URL);
    }

    handleToggleModal() {
        this.props.closeNonresidentialModal();
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    handleToggleErrorFetchingCountryOfResidenceModal() {
        this.props.requestProfile(true);
        this.props.closeErrorFetchingCountryOfResidenceModal();
        this.props.history.push(MYPROFILE_BROKER_ROBO_URL);
    }

    buildReadOnlyFinishButton(readOnly) {
        if (!readOnly) {
            return null;
        }

        return (
            <OKButton
                modifier="secondary"
                onClick={this.handleGoBackToTestStatus}
            >
                <FormattedText value="raSuitabilityTest-readOnlyFinishButton" />
            </OKButton>
        );
    }

    buildReadOnlyCancelButton(readOnly) {
        if (!readOnly) {
            return null;
        }

        return (
            <OKLink to={SUITABILITY_TEST_STATUS_URL}>
                <FormattedText value="raSuitabilityTest-readOnlyCancelButton" />
            </OKLink>
        );
    }

    buildZeroQuestionCancelButton() {
        return (
            <OKLink to={SUITABILITY_TEST_STATUS_URL}>
                <FormattedText
                    className="robowizard__cancel-button-label"
                    value="raSuitabilityTest-cancel"
                />
            </OKLink>
        );
    }

    buildFirstAnswerModal() {
        recordLink(
            PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_STATUS,
            PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1,
            PROC_RA_SUITABILITY_TEST_MODAL_ANSWER_1_OPEN,
        );
        return <RAFirstAnswerModal closeModal={this.handleNextModal} />;
    }

    buildCoherenceModal(message, isNonBlocking) {
        return (
            <RACoherenceModal
                message={message}
                closeModal={this.props.resetCoherenceError}
                isNonBlocking={isNonBlocking}
                onHandleContinueFromWarningModal={
                    this.handleContinueFromWarningModal
                }
            />
        );
    }

    buildTitleTooltip(dontShowInfoTooltip, tooltipText) {
        if (!dontShowInfoTooltip) {
            return null;
        }
        const target = (
            <div className="ra-sustainability-question__tooltip">
                <div className="ra-sustainability-question__tooltip-icon" />
            </div>
        );
        return (
            <OKTooltip
                target={target}
                content={tooltipText}
                offset={[0, -15]}
            />
        );
    }

    buildContentModalForInvestmentExperience() {
        const {
            immSuitabilityTest,
            handleCloseModalInvestmentExperience,
        } = this.props;
        const isOpenModalInvestmentExperience = immSuitabilityTest.get(
            'isOpenModalInvestmentExperience',
        );
        return {
            title: formatText(
                'raSuitabilityTest-investmentExperienceTitleModal',
            ),
            content: formatText(
                'raSuitabilityTest-investmentExperienceContentModal',
            ),
            buttonText: formatText(
                'raSuitabilityTest-investmentExperienceButtonTextModal',
            ),
            isOpen: isOpenModalInvestmentExperience,
            closeModal: handleCloseModalInvestmentExperience,
        };
    }

    buildFirstWizardCategory(disabled) {
        const {
            immSuitabilityTest,
            match: {
                params: { readOnly },
            },
            immGlobalVariables,
            immFlagBasedFeatures,
        } = this.props;
        const ffTestV6 = immFlagBasedFeatures.get(SUITABILITY_TEST_V6);
        const immQuestions = immSuitabilityTest.get('questions');
        const knowledgeTitle = immQuestions.getIn([KNOW_LEDGE, 'title']);
        const knowledgeList = immQuestions
            .getIn([KNOW_LEDGE, 'answers'])
            .toJS();
        const financialWorldAwarenessTitle = immQuestions.getIn([
            '102',
            'title',
        ]);
        const financialWorldAwarenessList = immQuestions
            .getIn(['102', 'answers'])
            .toJS();
        const financialToolsAwarenessTitle = immQuestions.getIn([
            '103',
            'title',
        ]);
        const financialToolsAwarenessList = immQuestions
            .getIn(['103', 'answers'])
            .toJS();
        const financialMarketRiskTitle = immQuestions.getIn(['104', 'title']);
        const financialMarketRiskList = immQuestions
            .getIn(['104', 'answers'])
            .toJS();
        const privacyLink = (
            <OKLink to={GDPRlink} target="_blank" modifier="inline">
                <FormattedText value="raSuitabilityTest-privacyDataProtection" />
            </OKLink>
        );
        const immAnswers = immSuitabilityTest.get('answers');
        const knowledgeSO = immAnswers.get(KNOW_LEDGE);
        const financialWorldAwarenessSO = immAnswers.get('102');
        const financialToolsAwarenessSO = immAnswers.get('103');
        const financialMarketRiskSO = immAnswers.get('104');
        const accordionStep = immSuitabilityTest.get('accordionStep');
        const contractedProductsFF = immFlagBasedFeatures.get(
            MIFID_TEST_CONTRACTED_PRODUCTS_COHERENCE_CONTROL,
        );
        const investmentExperience = immSuitabilityTest.get(
            'investmentExperience',
        );
        const showModal =
            !readOnly &&
            this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'showModal',
            ]) &&
            !immSuitabilityTest.get('isNonresidentialModalOpen') &&
            !immSuitabilityTest.get(
                'isErrorFetchingCountryOfResidenceModalOpen',
            );

        const GDPRlink = immGlobalVariables.getIn([
            'parameters',
            'contratos',
            'proteccion_datos',
        ]);

        const contentModal =
            contractedProductsFF &&
            investmentExperience &&
            this.buildContentModalForInvestmentExperience();

        const messageStepThreeForTestV6 = (
            <div className="ra-suitability-test-view__disclaimer-financialCultureDescription">
                <p>
                    <FormattedText value="raSuitabilityTest-financialCultureDescription" />
                </p>
            </div>
        );

        const listStep = [
            <RAWizardStep
                identifier={SUITABILITY_TEST_STEP_1}
                name={formatText('raSuitabilityTest-step2')}
            >
                <RARadioButtonStep
                    titleTooltip={this.buildTitleTooltip(
                        !disabled,
                        'raSuitabilityTest-tooltip1',
                    )}
                    selectedValue={knowledgeSO}
                    titleText={knowledgeTitle}
                    radioButtons={knowledgeList}
                    nameComponent={'ask1'}
                    idPrefix={'ask1'}
                    changeSelectedOption={this.props.updateKnowledgeOption}
                    disabled={disabled}
                />
                {this.renderDisclaimerTest()}
                <div className="ra-suitability-test-view__disclaimer-container">
                    <OKMessage type="informative">
                        <p>
                            <FormattedText value="raSuitabilityTest-privacyDisclaimer" />
                        </p>
                        <p>
                            <FormattedTextWithComponents
                                value="raSuitabilityTest-privacyMoreInfo"
                                injectedComponents={[privacyLink]}
                            />
                        </p>
                    </OKMessage>
                </div>
            </RAWizardStep>,
            <RAWizardStep
                identifier={SUITABILITY_TEST_STEP_2}
                name={formatText('raSuitabilityTest-step1')}
            >
                <RARadioButtonStep
                    titleTooltip={this.buildTitleTooltip(
                        !disabled,
                        'raSuitabilityTest-tooltip2',
                    )}
                    subTitleText={
                        <FormattedText
                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                            apiValue={KNOW_LEDGE}
                        />
                    }
                    selectedValue={financialWorldAwarenessSO}
                    titleText={financialWorldAwarenessTitle}
                    radioButtons={financialWorldAwarenessList}
                    nameComponent={'ask2'}
                    idPrefix={'ask2'}
                    changeSelectedOption={
                        this.props.updateFinancialAwarenessOption
                    }
                    disabled={disabled}
                />
            </RAWizardStep>,
        ];

        if (ffTestV6) {
            listStep.push(
                <RAWizardStep
                    identifier={SUITABILITY_TEST_STEP_3}
                    name={formatText('raSuitabilityTest-step3')}
                    stepSubtitle={formatText(
                        'raSuitabilityTest-financialCultureSubTitle',
                    )}
                >
                    <RARadioButtonStep
                        titleTooltip={this.buildTitleTooltip(
                            !disabled,
                            'raSuitabilityTest-tooltip3',
                        )}
                        explanationText={messageStepThreeForTestV6}
                        selectedValue={financialToolsAwarenessSO}
                        titleText={financialToolsAwarenessTitle}
                        radioButtons={financialToolsAwarenessList}
                        nameComponent={'ask3'}
                        idPrefix={'ask3'}
                        changeSelectedOption={e =>
                            this.props.updateToolsAwarenessOption(
                                e,
                                SUITABILITY_TEST_STEP_3,
                            )
                        }
                        disabled={disabled}
                    />
                </RAWizardStep>,
                <RAWizardStep
                    identifier={SUITABILITY_TEST_STEP_3_1}
                    stepSubtitle={formatText(
                        'raSuitabilityTest-financialCultureSubTitle',
                    )}
                >
                    <RARadioButtonStep
                        titleTooltip={this.buildTitleTooltip(
                            !disabled,
                            'raSuitabilityTest-tooltip3',
                        )}
                        selectedValue={financialMarketRiskSO}
                        titleText={financialMarketRiskTitle}
                        radioButtons={financialMarketRiskList}
                        nameComponent={'ask4'}
                        idPrefix={'ask4'}
                        changeSelectedOption={e =>
                            this.props.updateMarketRiskOption(
                                e,
                                SUITABILITY_TEST_STEP_3,
                            )
                        }
                        disabled={disabled}
                    />
                </RAWizardStep>,
            );
        } else {
            listStep.push(
                <RAWizardStep
                    identifier={SUITABILITY_TEST_STEP_3}
                    name={formatText('raSuitabilityTest-step3')}
                    stepSubtitle={formatText(
                        'raSuitabilityTest-financialCultureSubTitle',
                    )}
                >
                    <RARadioButtonStep
                        titleTooltip={this.buildTitleTooltip(
                            !disabled,
                            'raSuitabilityTest-tooltip3',
                        )}
                        selectedValue={financialToolsAwarenessSO}
                        titleText={financialToolsAwarenessTitle}
                        radioButtons={financialToolsAwarenessList}
                        nameComponent={'ask3'}
                        idPrefix={'ask3'}
                        changeSelectedOption={e =>
                            this.props.updateToolsAwarenessOption(
                                e,
                                SUITABILITY_TEST_STEP_3,
                            )
                        }
                        disabled={disabled}
                    />

                    <RARadioButtonStep
                        titleTooltip={this.buildTitleTooltip(
                            !disabled,
                            'raSuitabilityTest-tooltip3',
                        )}
                        selectedValue={financialMarketRiskSO}
                        titleText={financialMarketRiskTitle}
                        radioButtons={financialMarketRiskList}
                        nameComponent={'ask4'}
                        idPrefix={'ask4'}
                        changeSelectedOption={e =>
                            this.props.updateMarketRiskOption(
                                e,
                                SUITABILITY_TEST_STEP_3,
                            )
                        }
                        disabled={disabled}
                    />
                </RAWizardStep>,
            );
        }

        listStep.push(
            <RAWizardStep
                identifier={SUITABILITY_TEST_STEP_4}
                name={formatText('raSuitabilityTest-step4')}
                canContinue={true}
                shouldDisplayModal={true}
                showModal={showModal}
                closeModal={this.closeModal}
                handleNext={this.handleNextModal} // eslint-disable-line
                modalTitle={formatText(
                    'raSuitabilityTest-productsExperienceModalTitle',
                )}
                modalDescription={formatText(
                    'raSuitabilityTest-productsExperienceModal',
                )}
            >
                <RAAccordionStep
                    titleTooltip={this.buildTitleTooltip(
                        !disabled,
                        'raSuitabilityTest-tooltip4',
                    )}
                    rows={accordionStep.get('rows').toJS()}
                    title={accordionStep.get('title')}
                    subtitle={
                        <FormattedText
                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                            apiValue={FINANCIAL_EXPERIENCE}
                        />
                    }
                    expandedRowId={accordionStep.get('expandedRowId')}
                    expandAccordionRow={this.props.expandAccordionRow}
                    selectAccordionButton={this.props.selectAccordionButton}
                    disabled={disabled}
                    immAnswers={immAnswers}
                    openedTogglerText={formatText(
                        'raSuitabilityTest-accordionTogglerOpened',
                    )}
                    closedToggleText={formatText(
                        'raSuitabilityTest-accordionTogglerClosed',
                    )}
                    contentModal={contentModal}
                />
            </RAWizardStep>,
        );

        return listStep;
    }

    buildWizard() {
        const {
            immSuitabilityTest,
            match: {
                params: { readOnly },
            },
            immProfile,
            shouldDisplayModalProductKnowledge,
            immFlagBasedFeatures,
            setSustainabilityAnswer,
        } = this.props;

        const retryTest = immSuitabilityTest.get('retryTest');
        const immQuestions = immSuitabilityTest.get('questions');

        const radialMenuTitle = immQuestions.getIn([
            RADIAL_MENU_SUBTITLE,
            'title',
        ]);
        const radialMenuValues = immQuestions
            .getIn([RADIAL_MENU_SUBTITLE, 'answers'])
            .toJS();
        const investmentHorizonSliderTitle = immQuestions.getIn([
            INVESTMENT_HORIZON_SLIDER_SUBTITLE,
            'title',
        ]);
        const volatilityTitle = immQuestions.getIn(['219', 'title']);
        const incomingOutgoingsTitle = immQuestions.getIn([
            INCOMING_OUTGOINGS,
            'title',
        ]);
        const capitalRatioTitle = immQuestions.getIn(['322', 'title']);
        const capitalRatioList = immQuestions.getIn(['322', 'answers']).toJS();
        const backupPlanTitle = immQuestions.getIn(['323', 'title']);
        const backupPlanList = immQuestions.getIn(['323', 'answers']).toJS();
        const lastAnswer = immSuitabilityTest.get('lastAnswer');
        const formattedLastAnswer = lastAnswer && lastAnswer.toJS();

        const immAnswers = immSuitabilityTest.get('answers');

        const capitalRatioSO = immAnswers.get('322');
        const backupPlanSO = immAnswers.get('323');
        const volatilityValue = immAnswers.get('219');
        const volatilityAmount = immAnswers.get('701');
        const incomingValue = immAnswers.get(INCOMING_OUTGOINGS);
        const outgoingValue = immAnswers.get('321');
        const radialSelectedValue = immAnswers.get(RADIAL_MENU_SUBTITLE);
        const investmentHorizonSliderValue = immAnswers.get(
            INVESTMENT_HORIZON_SLIDER_SUBTITLE,
        );

        const categoriesHeader = this.buildCategoriesHeader(readOnly);
        const readOnlyFinishButton = this.buildReadOnlyFinishButton(readOnly);
        const readOnlyCancelButton = this.buildReadOnlyCancelButton(readOnly);
        const zeroQuestionCancelButton = this.buildZeroQuestionCancelButton();

        const isSendingTest = immSuitabilityTest.get('isSendingTest');
        const displayLeaveModal =
            !immSuitabilityTest.get('isNonresidentialModalOpen') &&
            !__CONTACT_CENTER__
                ? RA_SUITABILITY_TEST_DISPLAY_LEAVE_MODAL
                : !immSuitabilityTest.get(
                      'isErrorFetchingCountryOfResidenceModalOpen',
                  );
        const leaveModalMessage = __CONTACT_CENTER__
            ? formatText('roboWizard-leaveWithoutSavingConfirmationMessage')
            : undefined;
        const showCancelButtonTooltip = !__CONTACT_CENTER__;
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const isReviewing = immSuitabilityTest.get('isReviewing');
        const isZeroQuestionPresent = zeroQuestionPresent(
            immQuestions,
            readOnly,
        );

        if (isReviewing) {
            shouldDisplayModalProductKnowledge();
        }

        let zeroQuestionTitle;
        let zeroQuestionList;
        let zeroQuestionSO;
        let zeroQuestionLegalText;

        if (isZeroQuestionPresent) {
            zeroQuestionTitle = immQuestions.getIn([
                RA_ZERO_QUESTION_ID,
                'title',
            ]);
            zeroQuestionList = immQuestions
                .getIn([RA_ZERO_QUESTION_ID, 'answers'])
                .toJS();
            zeroQuestionSO = immAnswers.get(RA_ZERO_QUESTION_ID);
            zeroQuestionLegalText = (
                <RASuitabilityTestZeroQuestionLegalText
                    clientName={clientName}
                />
            );
        }
        const showModal =
            !readOnly &&
            this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'showModal',
            ]) &&
            !immSuitabilityTest.get('isNonresidentialModalOpen') &&
            !immSuitabilityTest.get(
                'isErrorFetchingCountryOfResidenceModalOpen',
            );

        const isZeroQuestionAnswered = immSuitabilityTest.get(
            'isZeroQuestionAnswered',
        );
        const answeredQuestionIds = immSuitabilityTest.get(
            'answeredQuestionIds',
        );

        return (
            <RAWizard
                identifier={SUITABILITY_TEST}
                handleNavigationRequest={this.props.validateStep}
                onFinish={this.handleFinish}
                readOnly={readOnly}
                isReviewing={isReviewing}
                categoriesHeader={categoriesHeader}
                finishButton={readOnlyFinishButton}
                cancelButton={
                    isZeroQuestionPresent
                        ? zeroQuestionCancelButton
                        : readOnlyCancelButton
                }
                handleCancel={this.handleCancel} // eslint-disable-line
                lastAnswer={
                    isZeroQuestionAnswered ? formattedLastAnswer : false
                }
                finishLoading={isSendingTest}
                displayLeaveModal={displayLeaveModal}
                retryTest={retryTest}
                leaveModalMessage={leaveModalMessage}
                showCancelButtonTooltip={showCancelButtonTooltip}
                answeredQuestionIds={answeredQuestionIds}
            >
                {({ disabled }) => {
                    let elements = [
                        <RAWizardCategory
                            identifier={SUITABILITY_TEST_CATEGORY_1}
                            key={SUITABILITY_TEST_CATEGORY_1}
                            name={formatText('raSuitabilityTest-category1')}
                            icon="universidad"
                        >
                            {this.buildFirstWizardCategory(disabled)}
                        </RAWizardCategory>,
                        <RAWizardCategory
                            identifier={SUITABILITY_TEST_CATEGORY_2}
                            key={SUITABILITY_TEST_CATEGORY_2}
                            name={formatText('raSuitabilityTest-category2')}
                            icon="objetivos"
                        >
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_5}
                                name={formatText('raSuitabilityTest-step5')}
                            >
                                <RARadialMenu
                                    titleTooltip={this.buildTitleTooltip(
                                        !disabled,
                                        'raSuitabilityTest-tooltip5',
                                    )}
                                    onRadialItemClick={
                                        this.handleUpdateObjective
                                    }
                                    selectedValue={radialSelectedValue}
                                    title={radialMenuTitle}
                                    subtitle={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                                            apiValue={RADIAL_MENU_SUBTITLE}
                                        />
                                    }
                                    disabled={disabled}
                                    values={radialMenuValues}
                                />
                            </RAWizardStep>
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_6}
                                name={formatText('raSuitabilityTest-step6')}
                            >
                                <div className="ra-suitability-test-view__investment-term-step">
                                    <div className="ra-suitability-test-view__step-title">
                                        {investmentHorizonSliderTitle}{' '}
                                        {this.buildTitleTooltip(
                                            !disabled,
                                            'raSuitabilityTest-tooltip6',
                                        )}
                                    </div>
                                    <div className="ra-suitability-test-view__step-subtitle">
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                                            apiValue={
                                                INVESTMENT_HORIZON_SLIDER_SUBTITLE
                                            }
                                        />
                                    </div>
                                    <div className="ra-suitability-test-view__horizon-slider">
                                        <div className="ra-suitability-test-view__horizon-slider--term">
                                            <RAInvestmentHorizonInput
                                                disabled={disabled}
                                                updateInvestmentHorizonSlider={
                                                    this.props
                                                        .updateTemporalHorizonValue
                                                }
                                                value={
                                                    investmentHorizonSliderValue
                                                }
                                            />
                                        </div>
                                        <div className="ra-suitability-test-view__horizon-slider--slider">
                                            <OKSliderInput
                                                defaultValue={
                                                    investmentHorizonSliderValue
                                                }
                                                disabled={disabled}
                                                hasInput={false}
                                                min={
                                                    RA_INVESTMENT_HORIZON_SLIDER_MIN
                                                }
                                                max={
                                                    RA_INVESTMENT_HORIZON_SLIDER_MAX
                                                }
                                                minLabel={formatText(
                                                    'investmentTermSlider-labelYear',
                                                )}
                                                maxLabel={formatText(
                                                    'investmentTermSlider-labelLimit',
                                                )}
                                                onChange={
                                                    this.handleUpdateTHValue
                                                }
                                            />
                                        </div>
                                    </div>
                                </div>
                            </RAWizardStep>
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_7}
                                name={formatText('raSuitabilityTest-step7')}
                                shouldDisplayModal={false}
                                showModal={showModal}
                                closeModal={this.closeModal}
                                handleNext={this.handleNextModal} // eslint-disable-line
                                modalTitle={formatText(
                                    'raSuitabilityTest-riskModalTitle',
                                )}
                                modalDescription={formatText(
                                    'raSuitabilityTest-riskModalDescription',
                                )}
                            >
                                <RAVerticalSliderStep
                                    titleTooltip={this.buildTitleTooltip(
                                        !disabled,
                                        'raSuitabilityTest-tooltipVerticalSlider',
                                    )}
                                    sliderValue={volatilityValue}
                                    changeSliderValue={
                                        this.props.updateVolatilityValue
                                    }
                                    amount={volatilityAmount}
                                    updateVolatilityInputValue={
                                        this.props.updateVolatilityInputValue
                                    }
                                    disabled={disabled}
                                    title={volatilityTitle}
                                    subtitle={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                                            apiValue={VOLATILITY_SUBTITLE}
                                        />
                                    }
                                    titleSlider={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionAnswersTitle"
                                            apiValue={VOLATILITY_SUBTITLE}
                                        />
                                    }
                                />
                            </RAWizardStep>
                        </RAWizardCategory>,
                        <RAWizardCategory
                            identifier={SUITABILITY_TEST_CATEGORY_3}
                            key={SUITABILITY_TEST_CATEGORY_3}
                            name={formatText('raSuitabilityTest-category3')}
                            icon="inversiones-ahorros"
                        >
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_8}
                                name={formatText('raSuitabilityTest-step8')}
                            >
                                <RAIncomingOutgoingStep
                                    titleTooltip={this.buildTitleTooltip(
                                        !disabled,
                                        'raSuitabilityTest-tooltip8',
                                    )}
                                    incomingValue={incomingValue}
                                    outgoingValue={outgoingValue}
                                    updateIncomingValue={
                                        this.props.updateIncomingValue
                                    }
                                    updateOutgoingValue={
                                        this.props.updateOutgoingValue
                                    }
                                    title={incomingOutgoingsTitle}
                                    subtitle={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                                            apiValue={INCOMING_OUTGOINGS}
                                        />
                                    }
                                    explanation={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionAnswersTitle"
                                            apiValue={INCOMING_OUTGOINGS}
                                        />
                                    }
                                    disabled={disabled}
                                />
                            </RAWizardStep>
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_9}
                                name={formatText('raSuitabilityTest-step9')}
                            >
                                <RANetworthPercentageSlider
                                    titleTooltip={this.buildTitleTooltip(
                                        !disabled,
                                        'raSuitabilityTest-tooltip9',
                                    )}
                                    value={capitalRatioSO}
                                    titleText={capitalRatioTitle}
                                    subtitleText={
                                        <FormattedText
                                            value="raSuitabilityTest-roboTestQuestionSubtitle"
                                            apiValue={capitalRatiosubtitle}
                                        />
                                    }
                                    steps={capitalRatioList}
                                    changeSelectedOption={
                                        this.props.updateCapitalRatioOption
                                    }
                                    disabled={disabled}
                                />
                            </RAWizardStep>
                            <RAWizardStep
                                identifier={SUITABILITY_TEST_STEP_10}
                                name={formatText('raSuitabilityTest-step10')}
                            >
                                <div className="ra-suitability-test-view__last-step-outer">
                                    <RARadioButtonStep
                                        titleTooltip={this.buildTitleTooltip(
                                            !disabled,
                                            'raSuitabilityTest-tooltip10',
                                        )}
                                        className="ra-suitability-test-view__last-step-inner"
                                        selectedValue={backupPlanSO}
                                        titleText={backupPlanTitle}
                                        subTitleText={
                                            <FormattedText
                                                value="raSuitabilityTest-roboTestQuestionSubtitle"
                                                apiValue={BACKUP_PLAN_TITLE}
                                            />
                                        }
                                        explanationText={
                                            <FormattedText
                                                value="raSuitabilityTest-roboTestQuestionAnswersTitle"
                                                apiValue={BACKUP_PLAN_TITLE}
                                            />
                                        }
                                        radioButtons={backupPlanList}
                                        nameComponent={'ask5'}
                                        idPrefix={'ask5'}
                                        changeSelectedOption={
                                            this.props.updateBackupPlanOption
                                        }
                                        disabled={disabled}
                                    />
                                </div>
                            </RAWizardStep>
                        </RAWizardCategory>,
                    ];

                    if (isZeroQuestionPresent) {
                        elements.unshift(
                            <RAWizardCategory
                                identifier={SUITABILITY_TEST_CATEGORY_0}
                                key={SUITABILITY_TEST_CATEGORY_0}
                                name="Motivos para volver a realizar el test"
                                isHidden={true}
                            >
                                <RAWizardStep
                                    identifier={SUITABILITY_TEST_STEP_0}
                                    name="Motivos para volver a realizar el test"
                                    shouldDisplayModal={false}
                                    nextButtonLabel={formatText(
                                        'raSuitabilityTest-zeroQuestionNextButtonLabel',
                                    )}
                                    showNextButtonIcon={false}
                                >
                                    {zeroQuestionLegalText}
                                    <RARadioButtonStep
                                        selectedValue={zeroQuestionSO}
                                        titleText={zeroQuestionTitle}
                                        radioButtons={zeroQuestionList}
                                        nameComponent={'ask0'}
                                        idPrefix={'ask0'}
                                        changeSelectedOption={
                                            this.props.updateZeroQuestionOption
                                        }
                                        disabled={disabled}
                                    />
                                </RAWizardStep>
                            </RAWizardCategory>,
                        );
                    }

                    if (
                        immFlagBasedFeatures.get(
                            SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST_COUNTRIES,
                        ) ||
                        immFlagBasedFeatures.get(
                            SUSTAINABILITY_QUESTIONS_SUITABILITY_TEST,
                        )
                    ) {
                        const currentSutainabilityQuestionId = immSuitabilityTest.get(
                            'currentSustainabilityQuestionId',
                        );
                        const sustainabilityQuestionTitle = immQuestions.get(
                            currentSutainabilityQuestionId,
                        )
                            ? immQuestions.getIn([
                                  currentSutainabilityQuestionId,
                                  'title',
                              ])
                            : '';
                        const sustainabilityAnswer = immAnswers.get(
                            currentSutainabilityQuestionId,
                        );

                        if (currentSutainabilityQuestionId === '401') {
                            elements.push(
                                <RAWizardCategory
                                    identifier={SUITABILITY_TEST_STEP_11}
                                    key={SUITABILITY_TEST_STEP_11}
                                    name={formatText(
                                        'raSuitabilityTest-sustainabilityQuestion_categoryName',
                                    )}
                                    icon="esg"
                                >
                                    <RAWizardStep
                                        identifier={SUITABILITY_TEST_STEP_11}
                                        name=""
                                        shouldDisplayModal={false}
                                    >
                                        <RASustainabilityQuestion
                                            immSuitabilityTest={
                                                immSuitabilityTest
                                            }
                                            setSustainabilityAnswer={
                                                setSustainabilityAnswer
                                            }
                                            sustainabilityAnswer={
                                                sustainabilityAnswer
                                            }
                                            sustainabilityQuestionTitle={
                                                sustainabilityQuestionTitle
                                            }
                                            cleanSutainabilityExtraQuestions={
                                                this.props
                                                    .cleanSutainabilityExtraQuestions
                                            }
                                            stepNumber={11}
                                        />
                                    </RAWizardStep>

                                    <RAWizardStep
                                        identifier={SUITABILITY_TEST_STEP_12}
                                    >
                                        <RASustainabilityInvestmentFactorsQuestion
                                            immAnswers={immAnswers}
                                            immSuitabilityTest={
                                                immSuitabilityTest
                                            }
                                            immQuestions={immQuestions}
                                            setSustainabilityInvestmentFactors={
                                                this.props
                                                    .setSustainabilityInvestmentFactors
                                            }
                                            setSustainabiltyPias={
                                                this.props.setSustainabiltyPias
                                            }
                                            setSustainabiltyTaxonomia={
                                                this.props
                                                    .setSustainabiltyTaxonomia
                                            }
                                            setSustainabiltyInvestmentObjective={
                                                this.props
                                                    .setSustainabiltyInvestmentObjective
                                            }
                                            cleanSutainabilityExtraQuestions={
                                                this.props
                                                    .cleanSutainabilityExtraQuestions
                                            }
                                            disabled={disabled}
                                        />
                                    </RAWizardStep>
                                </RAWizardCategory>,
                            );
                        } else {
                            elements.push(
                                <RAWizardCategory
                                    identifier={SUITABILITY_TEST_STEP_11}
                                    key={SUITABILITY_TEST_STEP_11}
                                    name={formatText(
                                        'raSuitabilityTest-sustainabilityQuestion_categoryName',
                                    )}
                                    icon="esg"
                                >
                                    <RAWizardStep
                                        identifier={SUITABILITY_TEST_STEP_11}
                                        name=""
                                        shouldDisplayModal={false}
                                        showNextButtonIcon={false}
                                    >
                                        <RASustainabilityQuestion
                                            immSuitabilityTest={
                                                immSuitabilityTest
                                            }
                                            setSustainabilityAnswer={
                                                setSustainabilityAnswer
                                            }
                                            sustainabilityAnswer={
                                                sustainabilityAnswer
                                            }
                                            sustainabilityQuestionTitle={
                                                sustainabilityQuestionTitle
                                            }
                                            stepNumber={11}
                                        />
                                    </RAWizardStep>
                                </RAWizardCategory>,
                            );
                        }
                    }

                    return elements;
                }}
            </RAWizard>
        );
    }

    buildSuccess(continueWithUnsuccess = false) {
        const {
            immFlagBasedFeatures,
            immPrinter,
            immProfile,
            immSignaturePattern,
            immSuitabilityTest,
            isReviewInProgress,
            resetTestCompleted,
            getTestPDF,
            dmsManagementPlanInit,
        } = this.props;
        const isDisabled = !__CONTACT_CENTER__
            ? !immSignaturePattern.get('isFetchingConfigSuccess') ||
              !immSignaturePattern.get('inputValueSMS')
            : !canFinishOperative(immSignaturePattern, immPrinter);

        const email = PersonalDataHelper.getEmail(immProfile);
        const clientName = PersonalDataHelper.getFullName(immProfile, false);
        const immResults = immSuitabilityTest.getIn(['results', 0]);
        const profile = immResults.get('clientRiskProfileTitle', '');
        const clientRiskProfile = immResults.get('clientRiskProfileTitle');
        const firstParagraph = immResults.get(
            'clientRiskProfileDescription',
            '',
        );
        const secondParagraph = immResults.get(
            'maxTypeOfProductDescription',
            '',
        );
        const disclaimer = immResults.get('resultDescription', '');
        const newMaxTypeOfProduct = immResults.get('maxTypeOfProduct', 0);
        const oldMaxTypeOfProduct = immSuitabilityTest
            .get('results')
            .filter(result => !!result.get('signed'))
            .getIn(['0', 'maxTypeOfProduct'], 0);
        const isAllowed = immFlagBasedFeatures.get(MODIFY_SUITABILITY_TEST);
        const immNewTestScenario = immResults.get('newTestScenario');
        const showTextStatus = isAllowed && !!immNewTestScenario;
        let newTestScenario;
        const isTestFrom = immSuitabilityTest.get('isTestFrom');
        if (showTextStatus) {
            if (
                isTestFrom === RA_SUITABILITY_TEST_MODIFYGOAL_OPERATION ||
                isTestFrom === RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION
            ) {
                newTestScenario = `${RA_SUITABILITY_TEST_MODIFYPORTFOLIO_OPERATION}_${immNewTestScenario}`;
            } else {
                newTestScenario =
                    isTestFrom === RA_SUITABILITY_TEST_HIRE_OPERATION
                        ? `${RA_SUITABILITY_TEST_HIRE_OPERATION}_${immNewTestScenario}`
                        : immNewTestScenario;
            }
            newTestScenario = `${RA_SUITABILITY_TEST_HEAD_OPERATION}${newTestScenario}`;
        }
        return (
            <RASuitabilityTestSuccess
                immFlagBasedFeatures={immFlagBasedFeatures}
                immSuitabilityTest={immSuitabilityTest}
                immResults={immResults}
                className="no-print-out"
                clientRiskProfile={clientRiskProfile}
                disclaimer={disclaimer}
                continueWithUnsuccess={continueWithUnsuccess}
                email={email}
                clientName={clientName}
                isDisabled={isDisabled}
                isReviewInProgress={isReviewInProgress}
                onConfirm={this.handleConfirm}
                profile={profile}
                resetTestCompleted={resetTestCompleted}
                secondParagraph={secondParagraph}
                headerDescription={firstParagraph}
                showTextStatus={showTextStatus}
                newMaxTypeOfProduct={newMaxTypeOfProduct}
                oldMaxTypeOfProduct={oldMaxTypeOfProduct}
                newTestScenario={newTestScenario}
                getTestPDF={getTestPDF}
                dmsManagementPlanInit={dmsManagementPlanInit}
            />
        );
    }

    buildFailure() {
        const { immProfile } = this.props;
        const email = PersonalDataHelper.getEmail(immProfile);
        return <RASuitabilityTestFailure email={email} />;
    }

    buildFailureDisclaimer() {
        const {
            immGlobalPosition,
            isReviewInProgress,
            resetTestCompleted,
            continueWithUnsuccess,
        } = this.props;
        return (
            <RASuitabilityTestFailureDisclaimer
                modalIsOpen={immGlobalPosition.get('hasRoboHired')}
                hasRoboPortfolio={immGlobalPosition.get('hasRoboHired')}
                isReviewInProgress={isReviewInProgress}
                resetTestCompleted={resetTestCompleted}
                continueWithUnsuccess={continueWithUnsuccess}
            />
        );
    }

    buildHeader() {
        const { immProfile } = this.props;

        const alias =
            immProfile.get('alias').trim() ||
            toCamelCase(immProfile.get('nombreCliente').trim());
        const avatarUrl = immProfile.get('avatar');

        let avatar;
        if (avatarUrl && !immProfile.get('isFetching')) {
            avatar = (
                <Avatar
                    imgDescription="avatar-robo-advisor-header"
                    imgType="header-mode"
                    imgUrl={avatarUrl}
                    id="avatar-robo-advisor-header"
                />
            );
        }

        const okCoverClassName = classNames('col-xs-12', {
            'ra-suitability-test-view__cover': !__CONTACT_CENTER__,
        });
        const language = getFormattedLanguage();
        const logo = language === LANGUAGE_ES ? 'es' : 'en';

        return (
            <OKCover section="generic" customClass={okCoverClassName}>
                <div className="ra-suitability-test-view__header-container">
                    <div className="ra-suitability-test-view__header-left-container">
                        <i
                            onClick={this.handleLogoClick}
                            className={`ra-suitability-test-view__header-logo-${logo}`}
                        />
                        <div className="ra-suitability-test-view__header-title">
                            <FormattedText value="raSuitabilityTest-title" />
                        </div>
                    </div>
                    <div className="ra-suitability-test-view__header-right-container">
                        <div className="ra-suitability-test-view__header-avatar-container">
                            {avatar}
                        </div>
                        <div className="ra-suitability-test-view__header-alias">
                            {alias}
                        </div>
                    </div>
                </div>
            </OKCover>
        );
    }

    buildErrorFeedback() {
        return (
            <div className="ra-suitability-test-view__error-feedback-container">
                <CustomMessageBox
                    icon="icon-warning"
                    title={formatText('raSuitabilityTest-errorFeedbackTitle')}
                    subtitle={formatText(
                        'raSuitabilityTest-errorFeedbackSubtitle',
                    )}
                    textLink={formatText(
                        'raSuitabilityTest-errorFeedbackBackButtonLabel',
                    )}
                    goBackHandler={this.handleGoBackToTestStatus} // eslint-disable-line
                    bypassWrapUpNotification={true}
                />
            </div>
        );
    }

    buildAccessModal(immSuitabilityTest, immCheckStatus, selectedGoal) {
        const lastAnswerIndex = immSuitabilityTest.getIn([
            'lastAnswer',
            'stepIndex',
        ]);
        const hireGoal = immSuitabilityTest.get('fromSetGoal');
        const hirePureStrategy = !hireGoal;
        const noValidTest =
            isNoValidTest(immCheckStatus) ||
            immSuitabilityTest.get('retryTest');
        let goalType;
        let dueDate;
        let accessModalScenario;
        let handleNewTestClick = () => {};

        if (noValidTest) {
            if (hirePureStrategy) {
                accessModalScenario = !!lastAnswerIndex
                    ? RA_MODAL_TYPE_5
                    : RA_MODAL_TYPE_1;
            } else {
                accessModalScenario = !!lastAnswerIndex
                    ? RA_MODAL_TYPE_6
                    : RA_MODAL_TYPE_2;
                goalType = selectedGoal;
            }
        }
        if (immCheckStatus.get('testInProgress')) {
            accessModalScenario = RA_MODAL_TYPE_3;
            dueDate = immSuitabilityTest.get('dueDate');
            handleNewTestClick = this.handleNewTestClick;
        }

        recordLink(
            PROC_RA_SUITABILITY_TEST_INTERACTION,
            PROC_RA_SUITABILITY_TEST_ACCESS_MODAL,
            PROC_RA_SUITABILITY_TEST_VIEW,
        );

        return (
            <RASuitabilityTestModal
                identifier={accessModalScenario}
                testDate={dueDate}
                typeGBI={goalType}
                primaryButtonAction={this.handleContinueAccessModal} // eslint-disable-line
                secondaryButtonAction={handleNewTestClick}
                closeModal={this.handleCloseAccessModal} // eslint-disable-line
            />
        );
    }

    buildRetryModal(selectedReason) {
        return (
            <RASuitabilityTestRetryModal
                selectedValue={selectedReason}
                closeModal={this.onHandleRetryModalClose}
                handleCancelButtonAction={this.onHandleRetryModalCancel}
                onRetryReasonChange={this.handleRetryReasonChange}
                handlePrimaryButtonAction={this.onHandleRetryModalAccept}
            />
        );
    }

    renderDisclaimerTest() {
        return (
            <div className="ra-suitability-test-view__disclaimer-test">
                <p>
                    <FormattedText value="raSuitabilityTest-testDisclaimer" />
                </p>
            </div>
        );
    }

    render() {
        const {
            immBrokerConsultMiFID,
            immCheckStatus,
            immSetGoal,
            immSuitabilityTest,
            immWizard,
            immFlagBasedFeatures,
            match: {
                params: { readOnly },
            },
        } = this.props;
        const { showRetryModal } = this.state;
        const immQuestions = immSuitabilityTest.get('questions');
        const isZeroQuestionPresent = zeroQuestionPresent(
            immQuestions,
            readOnly,
        );
        const showAccessModal =
            immCheckStatus.get('unSignedTest') ||
            (__CONTACT_CENTER__ && isZeroQuestionPresent)
                ? false
                : this.state.showAccessModal;
        const coherenceError = immSuitabilityTest.getIn([
            'coherenceError',
            'error',
        ]);
        const coherenceErrorMessage = immSuitabilityTest.getIn([
            'coherenceError',
            'message',
        ]);
        const isNonBlocking = immSuitabilityTest.getIn([
            'coherenceError',
            'isNonBlocking',
        ]);
        const displayNonResidentialModal = immSuitabilityTest.get(
            'isNonresidentialModalOpen',
        );
        const displayErrorFetchingCountryOfResidenceModal = immSuitabilityTest.get(
            'isErrorFetchingCountryOfResidenceModalOpen',
        );
        const hasOtherModal =
            displayNonResidentialModal ||
            displayErrorFetchingCountryOfResidenceModal;
        const coherenceModal = coherenceError
            ? this.buildCoherenceModal(coherenceErrorMessage, isNonBlocking)
            : null;
        const firstAnswerModal =
            this.props.immWizard.getIn([
                'persistedWizards',
                SUITABILITY_TEST,
                'showFirstAnswerModal',
            ]) && this.buildFirstAnswerModal();

        const errorFetchingQuestions = immSuitabilityTest.get(
            'errorFetchingQuestions',
        );
        const selectedGoal = immSetGoal.getIn([
            'steps',
            FIRST_STEP,
            'goalTypeSelected',
        ]);
        const lastAnswer = immSuitabilityTest.getIn([
            'lastAnswer',
            'stepIndex',
        ]);
        const retryTest = immSuitabilityTest.get('retryTest');
        const isStepRendered = !!lastAnswer
            ? lastAnswer + 1 ===
              immWizard.getIn([
                  'persistedWizards',
                  SUITABILITY_TEST,
                  'lastStepIndex',
              ])
            : true;
        const isPassedTest = immSuitabilityTest.getIn(
            ['results', 0, 'passedTest'],
            true,
        );

        let content = <LoadingSection />;
        let accessModal;
        let retryModal;

        if (!__CONTACT_CENTER__ && showRetryModal) {
            const selectedReason = immSuitabilityTest.get('retryReason');
            retryModal = this.buildRetryModal(selectedReason);
        }

        const isErrorFetchingQuestions =
            __CONTACT_CENTER__ && errorFetchingQuestions;

        if (!__CONTACT_CENTER__) {
            if (
                !showRetryModal &&
                showAccessModal &&
                !immSuitabilityTest.get('isFetchingQuestions') &&
                !readOnly &&
                !immWizard.get('persistedWizards').isEmpty() &&
                isStepRendered &&
                !displayNonResidentialModal &&
                (!retryTest || immCheckStatus.get('testInProgress'))
            )
                accessModal = this.buildAccessModal(
                    immSuitabilityTest,
                    immCheckStatus,
                    selectedGoal,
                );
        } else {
            if (
                !hasOtherModal &&
                !isErrorFetchingQuestions &&
                showAccessModal &&
                !immSuitabilityTest.get('isFetchingQuestions') &&
                !readOnly
            )
                accessModal = this.buildAccessModal(
                    immSuitabilityTest,
                    immCheckStatus,
                    selectedGoal,
                );
        }
        if (isErrorFetchingQuestions) {
            content = this.buildErrorFeedback();
        } else if (
            immSuitabilityTest.get('testCompleted') &&
            immBrokerConsultMiFID.get('fetched') &&
            !readOnly &&
            (isTestValid(immCheckStatus) ||
                immCheckStatus.get('unSignedTest') ||
                !isPassedTest ||
                retryTest)
        ) {
            const SaveTestFF = immFlagBasedFeatures.get(
                'sign_suitability_test_not_suitable',
            );
            const testSuccess = immSuitabilityTest.get('success');
            const continueWithUnsuccess = immSuitabilityTest.get(
                'continueWithUnsuccess',
            );
            if (SaveTestFF) {
                if (testSuccess) {
                    content = this.buildSuccess();
                } else {
                    content = continueWithUnsuccess
                        ? this.buildSuccess(true)
                        : this.buildFailureDisclaimer();
                }
            } else {
                content = testSuccess
                    ? this.buildSuccess()
                    : this.buildFailure();
            }
        } else if (
            immSuitabilityTest.get('questions').size > 0 &&
            immBrokerConsultMiFID.get('fetched')
        ) {
            content = this.buildWizard();
        }

        const header = this.buildHeader();
        const viewClassName = classNames('ra-suitability-test-view', {
            'ra-suitability-test-view--padding': immSuitabilityTest.get(
                'testCompleted',
            ),
        });

        const ffUsPersonSuitabilityTest = immFlagBasedFeatures.get(
            'wealth_suitability_test_us_person',
        );

        const contentRender = (
            <div className={viewClassName}>
                <RANonresidentialModal
                    showModal={displayNonResidentialModal}
                    title={formatText(
                        'raNonresidentialModal-titleNonObjective',
                    )}
                    closeModal={this.handleToggleModal} // eslint-disable-line
                    message={formatText('raNonresidentialModal-description')}
                    button={formatText('raNonresidentialModal-button')}
                    number={RA_NON_RESIDENTIAL_MODEL_CONTACT_NUMBER}
                />
                <RAErrorFetchingCountryOfResidenceModal
                    showModal={displayErrorFetchingCountryOfResidenceModal}
                    title={formatText(
                        'raErrorFetchingCountryOfResidenceModal-title',
                    )}
                    closeModal={
                        // eslint-disable-line
                        this.handleToggleErrorFetchingCountryOfResidenceModal
                    }
                    message={formatText(
                        'raErrorFetchingCountryOfResidenceModal-description',
                    )}
                    button={formatText(
                        'raErrorFetchingCountryOfResidenceModal-button',
                    )}
                />
                <div className="container-fluid">
                    <div className="row">{header}</div>
                </div>
                <div className="row">
                    {retryModal}
                    {accessModal}
                    {coherenceModal}
                    {firstAnswerModal}
                    <div
                        id="printable-wizard"
                        className="ra-suitability-test-view-content"
                    >
                        {content}
                    </div>
                </div>
            </div>
        );

        return (
            <ModalUsPersonBlock
                children={contentRender}
                featureFlag={ffUsPersonSuitabilityTest}
                titleKey={'us_person_popup-suitability_test_title'}
                description={'us_person_popup-suitability_test_message'}
                buttonClick={() => this.props.history.push(BROKER_PG_ROBO_URL)}
            />
        );
    }
}

RASuitabilityTestView.propTypes = {
    //All bellow are injected by connect
    cleanCovenientsQuestions: PropTypes.func.isRequired,
    continueWithUnsuccess: PropTypes.func.isRequired,
    expandAccordionRow: PropTypes.func,
    getTestQuestions: PropTypes.func.isRequired,
    hideAppHeader: PropTypes.func.isRequired,
    immBrokerConsultMiFID: PropTypes.object.isRequired,
    immCheckStatus: PropTypes.object.isRequired,
    immPrinter: PropTypes.object.isRequired,
    immProfile: PropTypes.object.isRequired,
    immFlagBasedFeatures: PropTypes.object.isRequired,
    immSetGoal: PropTypes.object.isRequired,
    immSignaturePattern: PropTypes.object.isRequired,
    immSuitabilityTest: PropTypes.object.isRequired,
    immWizard: PropTypes.object.isRequired,
    isReviewInProgress: PropTypes.func.isRequired,
    resetCoherenceError: PropTypes.func.isRequired,
    match: PropTypes.object,
    requestProfile: PropTypes.func.isRequired,
    selectAccordionButton: PropTypes.func,
    sendTest: PropTypes.func.isRequired,
    showModalNewQuestions: PropTypes.func.isRequired,
    setRetryReason: PropTypes.func.isRequired,
    showAccessModal: PropTypes.func.isRequired,
    showAppHeader: PropTypes.func.isRequired,
    shouldDisplayModalProductKnowledge: PropTypes.func,
    showModal: PropTypes.func,
    showFirstAnswerModal: PropTypes.func,
    signTest: PropTypes.func,
    updateBackupPlanOption: PropTypes.func,
    updateCapitalRatioOption: PropTypes.func,
    updateFinancialAwarenessOption: PropTypes.func,
    updateIncomingValue: PropTypes.func,
    updateKnowledgeOption: PropTypes.func,
    updateObjective: PropTypes.func,
    updateOutgoingValue: PropTypes.func,
    updateTemporalHorizonValue: PropTypes.func,
    updateToolsAwarenessOption: PropTypes.func,
    updateMarketRiskOption: PropTypes.func,
    updateVolatilityInputValue: PropTypes.func,
    updateVolatilityValue: PropTypes.func,
    updateZeroQuestionOption: PropTypes.func,
    validateStep: PropTypes.func,
    continueFromModalWarning: PropTypes.func,
    reset: PropTypes.func.isRequired,
    resetTestCompleted: PropTypes.func.isRequired,
    validateResidentiality: PropTypes.func.isRequired,
    closeNonresidentialModal: PropTypes.func.isRequired,
    closeErrorFetchingCountryOfResidenceModal: PropTypes.func.isRequired,
    resetAnswers: PropTypes.func.isRequired,
    getTestPDF: PropTypes.func.isRequired,
    setSustainabilityAnswer: PropTypes.func.isRequired,
    setSustainabilityInvestmentFactors: PropTypes.func.isRequired,
    setSustainabiltyPias: PropTypes.func.isRequired,
    setSustainabiltyTaxonomia: PropTypes.func.isRequired,
    setSustainabiltyInvestmentObjective: PropTypes.func.isRequired,
    setSustainabiltyOurStrategies: PropTypes.func.isRequired,
    cleanSutainabilityExtraQuestions: PropTypes.func.isRequired,
    immGlobalVariables: PropTypes.object.isRequired,
    immGlobalPosition: PropTypes.object.isRequired,
    history: PropTypes.object.isRequired,
    setTotalAnswers: PropTypes.func.isRequired,
    sendLogs: PropTypes.func.isRequired,
    handleCloseModalInvestmentExperience: PropTypes.func.isRequired,
    dmsManagementPlanInit: PropTypes.func.isRequired,
};

module.exports = connect(
    state => ({
        immBrokerConsultMiFID: state.brokerConsultMiFID,
        immCheckStatus: state.raCheckStatus,
        immPrinter: state.printer,
        immProfile: state.profile,
        immFlagBasedFeatures: state.flagBasedFeatures,
        immSetGoal: state.raSetGoal,
        immSignaturePattern: state.signaturePattern,
        immSuitabilityTest: state.raSuitabilityTest,
        immWizard: state.raWizard,
        immGlobalVariables: state.globalVariables.get('variables'),
        immGlobalPosition: state.raGlobalPosition,
    }),
    {
        expandAccordionRow: suitabilityActions.expandAccordionRow,
        getTestQuestions: suitabilityActions.getTestQuestions,
        hideAppHeader: screenActions.hideAppHeader,
        isReviewInProgress: suitabilityActions.isReviewInProgress,
        resetCoherenceError: suitabilityActions.resetCoherenceError,
        resetTestCompleted: suitabilityActions.resetTestCompleted,
        selectAccordionButton: suitabilityActions.selectAccordionButton,
        cleanCovenientsQuestions: suitabilityActions.cleanCovenientsQuestions,
        sendTest: suitabilityActions.sendTest,
        showModalNewQuestions: suitabilityActions.showModalNewQuestions,
        shouldDisplayModalProductKnowledge:
            suitabilityActions.shouldDisplayModalProductKnowledge,
        showAccessModal: suitabilityActions.showAccessModal,
        showAppHeader: screenActions.showAppHeader,
        showModal: wizardActions.showModal,
        showFirstAnswerModal: wizardActions.showFirstAnswerModal,
        signTest: suitabilityActions.signTest,
        updateBackupPlanOption: suitabilityActions.updateBackupPlanOption,
        updateCapitalRatioOption: suitabilityActions.updateCapitalRatioOption,
        updateFinancialAwarenessOption:
            suitabilityActions.updateFinancialAwarenessOption,
        updateIncomingValue: suitabilityActions.updateIncomingValue,
        updateKnowledgeOption: suitabilityActions.updateKnowledgeOption,
        updateObjective: suitabilityActions.updateObjective,
        updateOutgoingValue: suitabilityActions.updateOutgoingValue,
        updateTemporalHorizonValue:
            suitabilityActions.updateTemporalHorizonValue,
        updateToolsAwarenessOption:
            suitabilityActions.updateToolsAwarenessOption,
        updateMarketRiskOption: suitabilityActions.updateMarketRiskOption,
        updateVolatilityInputValue:
            suitabilityActions.updateVolatilityInputValue,
        updateVolatilityValue: suitabilityActions.updateVolatilityValue,
        updateZeroQuestionOption: suitabilityActions.updateZeroQuestionOption,
        validateStep: suitabilityActions.validateStep,
        continueFromModalWarning: suitabilityActions.continueFromModalWarning,
        reset: suitabilityActions.reset,
        setRetryReason: suitabilityActions.setRetryReason,
        validateResidentiality: suitabilityActions.validateResidentiality,
        closeNonresidentialModal: suitabilityActions.closeNonresidentialModal,
        closeErrorFetchingCountryOfResidenceModal:
            suitabilityActions.closeErrorFetchingCountryOfResidenceModal,
        resetAnswers: suitabilityActions.resetAnswers,
        continueWithUnsuccess: suitabilityActions.continueWithUnsuccess,
        requestProfile: profileActions.requestProfile,
        getTestPDF: suitabilityActions.getTestPDF,
        setSustainabilityAnswer: suitabilityActions.setSustainabilityAnswer,
        setSustainabilityInvestmentFactors:
            suitabilityActions.setSustainabilityInvestmentFactors,
        setSustainabiltyPias: suitabilityActions.setSustainabiltyPias,
        setSustainabiltyTaxonomia: suitabilityActions.setSustainabiltyTaxonomia,
        setSustainabiltyInvestmentObjective:
            suitabilityActions.setSustainabiltyInvestmentObjective,
        setSustainabiltyOurStrategies:
            suitabilityActions.setSustainabiltyOurStrategies,
        cleanSutainabilityExtraQuestions:
            suitabilityActions.cleanSutainabilityExtraQuestions,
        setTotalAnswers: wizardActions.setTotalAnswers,
        sendLogs: suitabilityActions.sendLogs,
        handleCloseModalInvestmentExperience:
            suitabilityActions.handleCloseModalInvestmentExperience,
        dmsManagementPlanInit: suitabilityActions.dmsManagementPlanInit,
    },
)(withRouter(RASuitabilityTestView));
